import { render, staticRenderFns } from "./VekilSorgulaForm.vue?vue&type=template&id=57e13ace"
import script from "./VekilSorgulaForm.vue?vue&type=script&lang=ts"
export * from "./VekilSorgulaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports